import React, { createContext, useContext, useState } from "react";
import { getUserId } from "~/lib/storage";

const UserContext = createContext<string | null>(null);

export const UserProvider = ({ children }: { children?: React.ReactNode }) => {
  const [userId] = useState(getUserId);
  return <UserContext.Provider value={userId}>{children}</UserContext.Provider>;
};

export const useUserId = () => {
  const userId = useContext(UserContext);
  if (!userId) {
    throw new Error("useUserId must be used within a UserProvider");
  }
  return userId;
};
